<template>
    <div id="ern-skip-navi" v-cloak>
        <a href="#st-container">본문 바로가기</a>
    </div>
    <Header v-show="isNaviVisible" />
    <div id="st-container">
        <router-view :key="$route.fullPath" />
    </div>
    <FloatingButton />
    <LayoutFooter />
</template>

<script setup>
    defineOptions({
        name: 'App',
    });

    import { onMounted } from 'vue';
    import { storeToRefs } from 'pinia';
    import Header from '@/components/layout/Header.vue';
    import LayoutFooter from '@/components/layout/LayoutFooter.vue';
    import FloatingButton from '@/components/common/FloatingButton.vue';
    import { useRootStore } from '@/stores/modules';

    const rootStore = useRootStore();
    const { isNaviVisible } = storeToRefs(rootStore);

    const setLocalFavicon = () => {
        if (process.env.NODE_ENV === 'development') {
            const favicon = document.createElement('link');
            favicon.rel = 'icon';
            favicon.href = '/favicon/logo.svg';
            document.head.appendChild(favicon);
        }
    };

    onMounted(() => {
        // 로컬 환경에서만 파비콘 설정
        setLocalFavicon();
        // URL과 selectedBranchId 동기화 리스너 설정
        window.addEventListener('popstate', () => {
            useRootStore().syncBranchFromUrl();
        });

        // Kakao SDK Init
        const kakaoJSKey = process.env.VUE_APP_KAKAO_JS_KEY;
        if (window.Kakao && !window.Kakao.isInitialized() && kakaoJSKey) {
            try {
                window.Kakao.init(kakaoJSKey);
            } catch (e) {
                console.error('Kakao Init Failed:', e);
            }
        }
    });
</script>
